"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6726],{

/***/ 1131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uB": function() { return /* binding */ addPN; },
/* harmony export */   "wu": function() { return /* binding */ addPT; },
/* harmony export */   "zJ": function() { return /* binding */ navTimingValues; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

// We don't use JSON.stringify directly on the performance timing data for these reasons:
// * Chrome has extra data in the performance object that we don't want to send all the time (wasteful)
// * Firefox fails to stringify the native object due to - http://code.google.com/p/v8/issues/detail?id=1223
// * The variable names are long and wasteful to transmit

// Add Performance Timing values to the given object.
// * Values are written relative to an offset to reduce their length (i.e. number of characters).
// * The offset is sent with the data
// * 0's are not included unless the value is a 'relative zero'
//

var START = 'Start';
var END = 'End';
var UNLOAD_EVENT = 'unloadEvent';
var REDIRECT = 'redirect';
var DOMAIN_LOOKUP = 'domainLookup';
var ONNECT = 'onnect';
var REQUEST = 'request';
var RESPONSE = 'response';
var LOAD_EVENT = 'loadEvent';
var DOM_CONTENT_LOAD_EVENT = 'domContentLoadedEvent';
const navTimingValues = [];
function getPntType(type) {
  if (typeof type === 'number') return type;
  const types = {
    navigate: undefined,
    reload: 1,
    back_forward: 2,
    prerender: 3
  };
  return types[type];
}
function addPT(offset, pt, v = {}, isL1Api = false) {
  if (!pt) return;
  v.of = offset;
  handleValue(v.of, v, 'n', true);
  handleValue(pt[UNLOAD_EVENT + START], v, 'u', isL1Api);
  handleValue(pt[REDIRECT + START], v, 'r', isL1Api);
  handleValue(pt[UNLOAD_EVENT + END], v, 'ue', isL1Api);
  handleValue(pt[REDIRECT + END], v, 're', isL1Api);
  handleValue(pt['fetch' + START], v, 'f', isL1Api);
  handleValue(pt[DOMAIN_LOOKUP + START], v, 'dn', isL1Api);
  handleValue(pt[DOMAIN_LOOKUP + END], v, 'dne', isL1Api);
  handleValue(pt['c' + ONNECT + START], v, 'c', isL1Api);
  handleValue(pt['secureC' + ONNECT + 'ion' + START], v, 's', isL1Api);
  handleValue(pt['c' + ONNECT + END], v, 'ce', isL1Api);
  handleValue(pt[REQUEST + START], v, 'rq', isL1Api);
  handleValue(pt[RESPONSE + START], v, 'rp', isL1Api);
  handleValue(pt[RESPONSE + END], v, 'rpe', isL1Api);
  handleValue(pt.domLoading, v, 'dl', isL1Api);
  handleValue(pt.domInteractive, v, 'di', isL1Api);
  handleValue(pt[DOM_CONTENT_LOAD_EVENT + START], v, 'ds', isL1Api);
  handleValue(pt[DOM_CONTENT_LOAD_EVENT + END], v, 'de', isL1Api);
  handleValue(pt.domComplete, v, 'dc', isL1Api);
  handleValue(pt[LOAD_EVENT + START], v, 'l', isL1Api);
  handleValue(pt[LOAD_EVENT + END], v, 'le', isL1Api);
  return v;
}

// Add Performance Navigation values to the given object
function addPN(pn, v) {
  handleValue(getPntType(pn.type), v, 'ty');
  handleValue(pn.redirectCount, v, 'rc');
  return v;
}

/**
 * By side effect, this modifies 'obj' with a mapping of the 'prop' provided to a 'value', and invalid values are not added.
 * On the other hand, the local navTimingValues array gets the value appended if valid and 'undefined' appended if invalid, regardless.
 */
function handleValue(value, obj, prop, isOldApi) {
  /*
  For L2 Timing API, the value will already be a relative-to-previous-document DOMHighResTimeStamp.
  For L1 (deprecated) Timing, the value is an UNIX epoch timestamp, which we will convert to a relative time using our offset.
  PNT.type is reported as undefined, 1, 2, etc -- note that zero-value properties will be recorded as 'undefined', however DEM interprets undefined "types" as "navigate"
  */
  if (typeof value === 'number' && value > 0) {
    // note that zero-value properties will be recorded as 'undefined'
    if (isOldApi) {
      const offset = obj?.of > 0 ? obj.of : 0; // expect an epoch timestamp, if called by addPT
      value = Math.max(value - offset, 0);
    }
    value = Math.round(value);
    obj[prop] = value;
    navTimingValues.push(value);
  } else navTimingValues.push(undefined);
}

/***/ }),

/***/ 2148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ VITAL_NAMES; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const VITAL_NAMES = {
  FIRST_PAINT: 'fp',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_INTERACTION: 'fi',
  LARGEST_CONTENTFUL_PAINT: 'lcp',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  INTERACTION_TO_NEXT_PAINT: 'inp',
  TIME_TO_FIRST_BYTE: 'ttfb'
};

/***/ }),

/***/ 3892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ firstContentfulPaint; }
/* harmony export */ });
/* harmony import */ var web_vitals_attribution__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8629);
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2656);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

// eslint-disable-next-line camelcase



const firstContentfulPaint = new _vital_metric__WEBPACK_IMPORTED_MODULE_3__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_2__/* .VITAL_NAMES.FIRST_CONTENTFUL_PAINT */ .S.FIRST_CONTENTFUL_PAINT);

/* First Contentful Paint - As of WV v3, it still imperfectly tries to detect document vis state asap and isn't supposed to report if page starts hidden. */
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .isBrowserScope */ .il) {
  // eslint-disable-next-line camelcase
  if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .iOSBelow16 */ .ux) {
    try {
      if (!_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .initiallyHidden */ .iS) {
        // see ios-version.js for detail on this following bug case; tldr: buffered flag doesn't work but getEntriesByType does
        const paintEntries = performance.getEntriesByType('paint');
        paintEntries.forEach(entry => {
          if (entry.name === 'first-contentful-paint') {
            firstContentfulPaint.update({
              value: Math.floor(entry.startTime)
            });
          }
        });
      }
    } catch (e) {
      // ignore
    }
  } else {
    (0,web_vitals_attribution__WEBPACK_IMPORTED_MODULE_0__/* .onFCP */ .a4)(({
      value,
      attribution
    }) => {
      if (_constants_runtime__WEBPACK_IMPORTED_MODULE_1__/* .initiallyHidden */ .iS || firstContentfulPaint.isValid) return;
      const attrs = {
        timeToFirstByte: attribution.timeToFirstByte,
        firstByteToFCP: attribution.firstByteToFCP,
        loadState: attribution.loadState
      };
      firstContentfulPaint.update({
        value,
        attrs
      });
    });
  }
}

/***/ }),

/***/ 3600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ firstPaint; }
/* harmony export */ });
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2656);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



const firstPaint = new _vital_metric__WEBPACK_IMPORTED_MODULE_2__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_1__/* .VITAL_NAMES.FIRST_PAINT */ .S.FIRST_PAINT);
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserScope */ .il) {
  const handleEntries = entries => {
    entries.forEach(entry => {
      if (entry.name === 'first-paint' && !firstPaint.isValid) {
        observer.disconnect();

        /* Initial hidden state and pre-rendering not yet considered for first paint. See web-vitals onFCP for example. */
        firstPaint.update({
          value: entry.startTime
        });
      }
    });
  };
  let observer;
  try {
    if (PerformanceObserver.supportedEntryTypes.includes('paint') && !_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .initiallyHidden */ .iS) {
      observer = new PerformanceObserver(list => {
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(() => {
          handleEntries(list.getEntries());
        });
      });
      observer.observe({
        type: 'paint',
        buffered: true
      });
    }
  } catch (e) {
    // Do nothing.
  }
}

/***/ }),

/***/ 2656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ VitalMetric; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
class VitalMetric {
  #subscribers = new Set();
  history = [];
  constructor(name, roundingMethod) {
    this.name = name;
    this.attrs = {};
    this.roundingMethod = typeof roundingMethod === 'function' ? roundingMethod : Math.floor;
  }
  update({
    value,
    attrs = {}
  }) {
    if (value === undefined || value === null || value < 0) return;
    const state = {
      value: this.roundingMethod(value),
      name: this.name,
      attrs
    };
    this.history.push(state);
    this.#subscribers.forEach(cb => {
      try {
        cb(state);
      } catch (e) {
        // ignore errors
      }
    });
  }
  get current() {
    return this.history[this.history.length - 1] || {
      value: undefined,
      name: this.name,
      attrs: {}
    };
  }
  get isValid() {
    return this.current.value >= 0;
  }
  subscribe(callback, buffered = true) {
    if (typeof callback !== 'function') return;
    this.#subscribers.add(callback);
    // emit full history on subscription ("buffered" behavior)
    if (this.isValid && !!buffered) this.history.forEach(state => {
      callback(state);
    });
    return () => {
      this.#subscribers.delete(callback);
    };
  }
}

/***/ }),

/***/ 8629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NO": function() { return /* binding */ ot; },
/* harmony export */   "Yn": function() { return /* binding */ rt; },
/* harmony export */   "a4": function() { return /* binding */ w; },
/* harmony export */   "mr": function() { return /* binding */ ft; },
/* harmony export */   "mw": function() { return /* binding */ D; }
/* harmony export */ });
/* unused harmony exports CLSThresholds, FCPThresholds, FIDThresholds, INPThresholds, LCPThresholds, TTFBThresholds, onFID */
var t,e,n=function(){var t=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},r=function(t){if("loading"===document.readyState)return"loading";var e=n();if(e){if(t<e.domInteractive)return"loading";if(0===e.domContentLoadedEventStart||t<e.domContentLoadedEventStart)return"dom-interactive";if(0===e.domComplete||t<e.domComplete)return"dom-content-loaded"}return"complete"},i=function(t){var e=t.nodeName;return 1===t.nodeType?e.toLowerCase():e.toUpperCase().replace(/^#/,"")},a=function(t,e){var n="";try{for(;t&&9!==t.nodeType;){var r=t,a=r.id?"#"+r.id:i(r)+(r.classList&&r.classList.value&&r.classList.value.trim()&&r.classList.value.trim().length?"."+r.classList.value.trim().replace(/\s+/g,"."):"");if(n.length+a.length>(e||100)-1)return n||a;if(n=n?a+">"+n:a,r.id)break;t=r.parentNode}}catch(t){}return n},o=-1,c=function(){return o},u=function(t){addEventListener("pageshow",(function(e){e.persisted&&(o=e.timeStamp,t(e))}),!0)},s=function(){var t=n();return t&&t.activationStart||0},f=function(t,e){var r=n(),i="navigate";c()>=0?i="back-forward-cache":r&&(document.prerendering||s()>0?i="prerender":document.wasDiscarded?i="restore":r.type&&(i=r.type.replace(/_/g,"-")));return{name:t,value:void 0===e?-1:e,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},d=function(t,e,n){try{if(PerformanceObserver.supportedEntryTypes.includes(t)){var r=new PerformanceObserver((function(t){Promise.resolve().then((function(){e(t.getEntries())}))}));return r.observe(Object.assign({type:t,buffered:!0},n||{})),r}}catch(t){}},l=function(t,e,n,r){var i,a;return function(o){e.value>=0&&(o||r)&&((a=e.value-(i||0))||void 0===i)&&(i=e.value,e.delta=a,e.rating=function(t,e){return t>e[1]?"poor":t>e[0]?"needs-improvement":"good"}(e.value,n),t(e))}},m=function(t){requestAnimationFrame((function(){return requestAnimationFrame((function(){return t()}))}))},p=function(t){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&t()}))},v=function(t){var e=!1;return function(){e||(t(),e=!0)}},g=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},T=function(t){"hidden"===document.visibilityState&&g>-1&&(g="visibilitychange"===t.type?t.timeStamp:0,E())},y=function(){addEventListener("visibilitychange",T,!0),addEventListener("prerenderingchange",T,!0)},E=function(){removeEventListener("visibilitychange",T,!0),removeEventListener("prerenderingchange",T,!0)},S=function(){return g<0&&(g=h(),y(),u((function(){setTimeout((function(){g=h(),y()}),0)}))),{get firstHiddenTime(){return g}}},b=function(t){document.prerendering?addEventListener("prerenderingchange",(function(){return t()}),!0):t()},L=[1800,3e3],C=function(t,e){e=e||{},b((function(){var n,r=S(),i=f("FCP"),a=d("paint",(function(t){t.forEach((function(t){"first-contentful-paint"===t.name&&(a.disconnect(),t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-s(),0),i.entries.push(t),n(!0)))}))}));a&&(n=l(t,i,L,e.reportAllChanges),u((function(r){i=f("FCP"),n=l(t,i,L,e.reportAllChanges),m((function(){i.value=performance.now()-r.timeStamp,n(!0)}))})))}))},M=[.1,.25],D=function(t,e){!function(t,e){e=e||{},C(v((function(){var n,r=f("CLS",0),i=0,a=[],o=function(t){t.forEach((function(t){if(!t.hadRecentInput){var e=a[0],n=a[a.length-1];i&&t.startTime-n.startTime<1e3&&t.startTime-e.startTime<5e3?(i+=t.value,a.push(t)):(i=t.value,a=[t])}})),i>r.value&&(r.value=i,r.entries=a,n())},c=d("layout-shift",o);c&&(n=l(t,r,M,e.reportAllChanges),p((function(){o(c.takeRecords()),n(!0)})),u((function(){i=0,r=f("CLS",0),n=l(t,r,M,e.reportAllChanges),m((function(){return n()}))})),setTimeout(n,0))})))}((function(e){var n=function(t){var e,n={};if(t.entries.length){var i=t.entries.reduce((function(t,e){return t&&t.value>e.value?t:e}));if(i&&i.sources&&i.sources.length){var o=(e=i.sources).find((function(t){return t.node&&1===t.node.nodeType}))||e[0];o&&(n={largestShiftTarget:a(o.node),largestShiftTime:i.startTime,largestShiftValue:i.value,largestShiftSource:o,largestShiftEntry:i,loadState:r(i.startTime)})}}return Object.assign(t,{attribution:n})}(e);t(n)}),e)},w=function(t,e){C((function(e){var i=function(t){var e={timeToFirstByte:0,firstByteToFCP:t.value,loadState:r(c())};if(t.entries.length){var i=n(),a=t.entries[t.entries.length-1];if(i){var o=i.activationStart||0,u=Math.max(0,i.responseStart-o);e={timeToFirstByte:u,firstByteToFCP:t.value-u,loadState:r(t.entries[0].startTime),navigationEntry:i,fcpEntry:a}}}return Object.assign(t,{attribution:e})}(e);t(i)}),e)},x=0,I=1/0,k=0,A=function(t){t.forEach((function(t){t.interactionId&&(I=Math.min(I,t.interactionId),k=Math.max(k,t.interactionId),x=k?(k-I)/7+1:0)}))},F=function(){return t?x:performance.interactionCount||0},P=function(){"interactionCount"in performance||t||(t=d("event",A,{type:"event",buffered:!0,durationThreshold:0}))},B=[],O=new Map,R=0,j=function(){var t=Math.min(B.length-1,Math.floor((F()-R)/50));return B[t]},q=[],H=function(t){if(q.forEach((function(e){return e(t)})),t.interactionId||"first-input"===t.entryType){var e=B[B.length-1],n=O.get(t.interactionId);if(n||B.length<10||t.duration>e.latency){if(n)t.duration>n.latency?(n.entries=[t],n.latency=t.duration):t.duration===n.latency&&t.startTime===n.entries[0].startTime&&n.entries.push(t);else{var r={id:t.interactionId,latency:t.duration,entries:[t]};O.set(r.id,r),B.push(r)}B.sort((function(t,e){return e.latency-t.latency})),B.length>10&&B.splice(10).forEach((function(t){return O.delete(t.id)}))}}},N=function(t){var e=self.requestIdleCallback||self.setTimeout,n=-1;return t=v(t),"hidden"===document.visibilityState?t():(n=e(t),p(t)),n},W=[200,500],z=function(t,e){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(e=e||{},b((function(){var n;P();var r,i=f("INP"),a=function(t){N((function(){t.forEach(H);var e=j();e&&e.latency!==i.value&&(i.value=e.latency,i.entries=e.entries,r())}))},o=d("event",a,{durationThreshold:null!==(n=e.durationThreshold)&&void 0!==n?n:40});r=l(t,i,W,e.reportAllChanges),o&&(o.observe({type:"first-input",buffered:!0}),p((function(){a(o.takeRecords()),r(!0)})),u((function(){R=F(),B.length=0,O.clear(),i=f("INP"),r=l(t,i,W,e.reportAllChanges)})))})))},U=[],V=[],_=0,G=new WeakMap,J=new Map,K=-1,Q=function(t){U=U.concat(t),X()},X=function(){K<0&&(K=N(Y))},Y=function(){J.size>10&&J.forEach((function(t,e){O.has(e)||J.delete(e)}));var t=B.map((function(t){return G.get(t.entries[0])})),e=V.length-50;V=V.filter((function(n,r){return r>=e||t.includes(n)}));for(var n=new Set,r=0;r<V.length;r++){var i=V[r];nt(i.startTime,i.processingEnd).forEach((function(t){n.add(t)}))}var a=U.length-1-50;U=U.filter((function(t,e){return t.startTime>_&&e>a||n.has(t)})),K=-1};q.push((function(t){t.interactionId&&t.target&&!J.has(t.interactionId)&&J.set(t.interactionId,t.target)}),(function(t){var e,n=t.startTime+t.duration;_=Math.max(_,t.processingEnd);for(var r=V.length-1;r>=0;r--){var i=V[r];if(Math.abs(n-i.renderTime)<=8){(e=i).startTime=Math.min(t.startTime,e.startTime),e.processingStart=Math.min(t.processingStart,e.processingStart),e.processingEnd=Math.max(t.processingEnd,e.processingEnd),e.entries.push(t);break}}e||(e={startTime:t.startTime,processingStart:t.processingStart,processingEnd:t.processingEnd,renderTime:n,entries:[t]},V.push(e)),(t.interactionId||"first-input"===t.entryType)&&G.set(t,e),X()}));var Z,$,tt,et,nt=function(t,e){for(var n,r=[],i=0;n=U[i];i++)if(!(n.startTime+n.duration<t)){if(n.startTime>e)break;r.push(n)}return r},rt=function(t,n){e||(e=d("long-animation-frame",Q)),z((function(e){var n=function(t){var e=t.entries[0],n=G.get(e),i=e.processingStart,o=n.processingEnd,c=n.entries.sort((function(t,e){return t.processingStart-e.processingStart})),u=nt(e.startTime,o),s=t.entries.find((function(t){return t.target})),f=s&&s.target||J.get(e.interactionId),d=[e.startTime+e.duration,o].concat(u.map((function(t){return t.startTime+t.duration}))),l=Math.max.apply(Math,d),m={interactionTarget:a(f),interactionTargetElement:f,interactionType:e.name.startsWith("key")?"keyboard":"pointer",interactionTime:e.startTime,nextPaintTime:l,processedEventEntries:c,longAnimationFrameEntries:u,inputDelay:i-e.startTime,processingDuration:o-i,presentationDelay:Math.max(l-o,0),loadState:r(e.startTime)};return Object.assign(t,{attribution:m})}(e);t(n)}),n)},it=[2500,4e3],at={},ot=function(t,e){!function(t,e){e=e||{},b((function(){var n,r=S(),i=f("LCP"),a=function(t){e.reportAllChanges||(t=t.slice(-1)),t.forEach((function(t){t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-s(),0),i.entries=[t],n())}))},o=d("largest-contentful-paint",a);if(o){n=l(t,i,it,e.reportAllChanges);var c=v((function(){at[i.id]||(a(o.takeRecords()),o.disconnect(),at[i.id]=!0,n(!0))}));["keydown","click"].forEach((function(t){addEventListener(t,(function(){return N(c)}),{once:!0,capture:!0})})),p(c),u((function(r){i=f("LCP"),n=l(t,i,it,e.reportAllChanges),m((function(){i.value=performance.now()-r.timeStamp,at[i.id]=!0,n(!0)}))}))}}))}((function(e){var r=function(t){var e={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadDuration:0,elementRenderDelay:t.value};if(t.entries.length){var r=n();if(r){var i=r.activationStart||0,o=t.entries[t.entries.length-1],c=o.url&&performance.getEntriesByType("resource").filter((function(t){return t.name===o.url}))[0],u=Math.max(0,r.responseStart-i),s=Math.max(u,c?(c.requestStart||c.startTime)-i:0),f=Math.max(s,c?c.responseEnd-i:0),d=Math.max(f,o.startTime-i);e={element:a(o.element),timeToFirstByte:u,resourceLoadDelay:s-u,resourceLoadDuration:f-s,elementRenderDelay:d-f,navigationEntry:r,lcpEntry:o},o.url&&(e.url=o.url),c&&(e.lcpResourceEntry=c)}}return Object.assign(t,{attribution:e})}(e);t(r)}),e)},ct=[800,1800],ut=function t(e){document.prerendering?b((function(){return t(e)})):"complete"!==document.readyState?addEventListener("load",(function(){return t(e)}),!0):setTimeout(e,0)},st=function(t,e){e=e||{};var r=f("TTFB"),i=l(t,r,ct,e.reportAllChanges);ut((function(){var a=n();a&&(r.value=Math.max(a.responseStart-s(),0),r.entries=[a],i(!0),u((function(){r=f("TTFB",0),(i=l(t,r,ct,e.reportAllChanges))(!0)})))}))},ft=function(t,e){st((function(e){var n=function(t){var e={waitingDuration:0,cacheDuration:0,dnsDuration:0,connectionDuration:0,requestDuration:0};if(t.entries.length){var n=t.entries[0],r=n.activationStart||0,i=Math.max((n.workerStart||n.fetchStart)-r,0),a=Math.max(n.domainLookupStart-r,0),o=Math.max(n.connectStart-r,0),c=Math.max(n.connectEnd-r,0);e={waitingDuration:i,cacheDuration:a-i,dnsDuration:o-a,connectionDuration:c-o,requestDuration:t.value-c,navigationEntry:n}}return Object.assign(t,{attribution:e})}(e);t(n)}),e)},dt={passive:!0,capture:!0},lt=new Date,mt=function(t,e){Z||(Z=e,$=t,tt=new Date,gt(removeEventListener),pt())},pt=function(){if($>=0&&$<tt-lt){var t={entryType:"first-input",name:Z.type,target:Z.target,cancelable:Z.cancelable,startTime:Z.timeStamp,processingStart:Z.timeStamp+$};et.forEach((function(e){e(t)})),et=[]}},vt=function(t){if(t.cancelable){var e=(t.timeStamp>1e12?new Date:performance.now())-t.timeStamp;"pointerdown"==t.type?function(t,e){var n=function(){mt(t,e),i()},r=function(){i()},i=function(){removeEventListener("pointerup",n,dt),removeEventListener("pointercancel",r,dt)};addEventListener("pointerup",n,dt),addEventListener("pointercancel",r,dt)}(e,t):mt(e,t)}},gt=function(t){["mousedown","keydown","touchstart","pointerdown"].forEach((function(e){return t(e,vt,dt)}))},ht=(/* unused pure expression or super */ null && ([100,300])),Tt=function(t,e){e=e||{},b((function(){var n,r=S(),i=f("FID"),a=function(t){t.startTime<r.firstHiddenTime&&(i.value=t.processingStart-t.startTime,i.entries.push(t),n(!0))},o=function(t){t.forEach(a)},c=d("first-input",o);n=l(t,i,ht,e.reportAllChanges),c&&(p(v((function(){o(c.takeRecords()),c.disconnect()}))),u((function(){var r;i=f("FID"),n=l(t,i,ht,e.reportAllChanges),et=[],$=-1,Z=null,gt(addEventListener),r=a,et.push(r),pt()})))}))},yt=function(t,e){Tt((function(e){var n=function(t){var e=t.entries[0],n={eventTarget:a(e.target),eventType:e.name,eventTime:e.startTime,eventEntry:e,loadState:r(e.startTime)};return Object.assign(t,{attribution:n})}(e);t(n)}),e)};


/***/ })

}]);